import { getConfiguration, verifyExtend, extendError } from "./extend-utils.js";
import { initCartOffer } from "./extend-cart.js";

let offerElement = null;
let productForm = null;
let addToCartButton = null;
let params = null;
let config = null;

function verifyProductOffer() {
    const checks = { productForm, addToCartButton, params };
    
    if (!productForm || !addToCartButton || !params?.referenceId) {
        throw new Error("Missing required elements for Extend offer");
    }
    
    verifyExtend();
}

function modalDone() {
    addToCartButton.removeEventListener('click', handleAddToCart, true);
    addToCartButton.click();
    addToCartButton.addEventListener('click', handleAddToCart, true);

    if (config.dispatchSideCart) {
        setTimeout(() => initCartOffer(), 500);
    }
}

function handleAddToCart(e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    
    const quantityEl = productForm.querySelector('[name="quantity"]');
    const quantity = quantityEl?.value || 1;
    
    ExtendShopify.handleAddToCart(offerElement, {
        quantity,
        modal: config.modalOfferEnabled,
        done: modalDone
    });
}

function handleVariantChange() {
    if (offerElement) {
        offerElement.style.height = `${offerElement.clientHeight}px`;
    }

    params.referenceId = productForm.id.value;
    params.price = meta.product.variants.find(
        v => v.id == params.referenceId
    )?.price;
    
    Extend.setActiveProduct(offerElement, params);
}

function bindEvents() {
    addToCartButton.addEventListener('click', handleAddToCart, true);
    productForm.addEventListener('change', handleVariantChange, true);
}

export function initProductOffer() {
    try {
        if (meta.page.pageType != 'product' || !meta.product) {
            return;
        }
    } catch (err) {
        console.warn(err);
        return;
    }

    productForm = document.querySelector('[data-type="add-to-cart-form"]');
    addToCartButton = productForm?.querySelector('button[name="add"]') || 
                      document.querySelector('button[name="add"]');
    
    if (!productForm || !addToCartButton) {
        console.warn('Product form or button not found');
        return;
    }

    const referenceId = productForm.id.value;
    const variant = meta.product.variants.find(v => v.id == referenceId);
    
    params = {
        referenceId,
        price: variant?.price,
        category: meta.product.type
    };
    
    config = getConfiguration();
    config.dispatchSideCart = false;

    try {
        verifyProductOffer();
    } catch (err) {
        console.error(err);
        return;
    }

    offerElement = document.createElement('div');
    offerElement.className = 'extend-product-offer';
    offerElement.style.display = config.pdpOfferEnabled ? 'block' : 'none';
    
    bindEvents();
    Extend.buttons.render(offerElement, params);
    
    addToCartButton.parentElement.before(offerElement);
}